<template>
  <section v-if="media?.length" class="overflow-hidden mt-30 lg:mt-90">
    <div class="container-desktop 3xl:max-w-edge">
      <Slider
        id="product-images"
        ref="slider"
        class="details-slider"
        arrows
        :panels-per-view="panelsPerView"
      >
        <div
          v-for="(item, i) in media"
          :key="i"
          class="w-full pl-25 md:pl-0 md:mr-20 lg:mr-30"
        >
          <template v-if="item.__typename === 'MediaImage'">
            <div
              class="details-slider-image w-full cursor-zoom-in aspect-[4/3] flex items-center"
              v-bind="getItemAttributes(i)"
              @click="openLightbox(i)"
            >
              <MediaImage v-bind="item" :image-style="imageStyle" />
            </div>
            <div
              v-if="item.caption"
              class="font-helvetica text-lg font-light mt-20"
              v-html="item.caption"
            />
          </template>

          <template v-else-if="item.__typename === 'MediaVideo'">
            <div
              class="w-full aspect-[1/1] cursor-zoom-in"
              v-bind="getItemAttributes(i)"
              @click="openLightbox(i)"
            >
              <ProductSliderVideo :video="item" />
            </div>
          </template>
        </div>
      </Slider>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { ProductFragment } from '#graphql-operations'
import type { LightboxMediaItem } from '~/composables/useLightbox'
import type Slider from '~/components/Slider/index.vue'
import { defineExpedImageStyle } from '~~/utils/defineExpedImageStyle'

type ProductMedia = NonNullable<ProductFragment['detailImages']>[number]

const { isMobile } = useViewport()

const props = withDefaults(
  defineProps<{
    media?: ProductMedia[]
  }>(),
  {
    media: () => [],
  },
)

const slider = ref<InstanceType<typeof Slider> | null>(null)

const { openLightbox, getItemAttributes } = useLightbox(
  'product-images',
  props.media as LightboxMediaItem[],
  {
    slider,
    showCaption: true,
  },
)

const panelsPerView = computed(() => (isMobile.value ? 1.5 : 3))

const imageStyle = defineExpedImageStyle({
  type: 'sizes',
  aspectRatio: 4 / 3,
  cropType: 'cover',
  sizes: {
    xs: 450,
    lg: 300,
    xl: 500,
    '3xl': 768,
  },
})
</script>
